import { ClaimPrizeComponent } from './claim-prize.component';

export const ClaimPrizePage = () => {
  return <ClaimPrizeComponent />;
};
